import { useCallback } from 'react';
import type { Category } from '../../shared/api';
import { api } from '../lib/api';
import { useResource } from './useResource';

/** The signed-in user's categories (built-in first), with a helper to add one. */
export function useCategories() {
  const resource = useResource('categories', api.listCategories);
  const { reload } = resource;

  const create = useCallback(
    async (name: string): Promise<Category> => {
      const category = await api.createCategory(name);
      reload();
      return category;
    },
    [reload],
  );

  return { categories: resource.data, error: resource.error, reload, create };
}
